<template>
    <div class="price-specification">
        <PriceSpecificationRoom
            v-for="(room, roomIndex) in product.Rooms"
            :product="product"
            :room="room"
            :index="roomIndex"
            :key="roomIndex" />

        <PriceSpecificationRow
            :price="productPricing.price"
            :description="t({ key: 'checkout.total_to_pay' })"
            class="total" />
    </div>
</template>

<script lang="ts">
    import { computed, defineComponent, PropType } from 'vue';
    import { t } from '@shared/helpers/translation';
    import { getProductPricing } from '@/helpers/price';
    import { HotelProduct } from '@/api/Cart/cart.interfaces';
    import PriceSpecificationRow from '../PriceSpecificationRow.vue';
    import PriceSpecificationRoom from './PriceSpecificationRoom.vue';

    export default defineComponent({
        name: 'PriceSpecificationHotel',
        methods: { t },
        components: { PriceSpecificationRow, PriceSpecificationRoom },
        props: {
            product: {
                type: Object as PropType<HotelProduct>,
                required: true,
            },
        },
        setup(props) {
            const productPricing = computed(() => getProductPricing(props.product));

            return {
                productPricing,
            };
        },
    });
</script>

<style lang="scss">
    @forward '@/components/shared/PriceSpecification/PriceSpecification';
</style>
